module.exports = __webpack_public_path__ + "static/media/truckIcon.4edfb2fa.svg";